import React, { ReactNode, useEffect, useState } from 'react';

import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { useQuery } from 'react-query';

import { getIsOktaOn, getIsOktaOnKey } from '../../../services/home.service';

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  window.location.replace(toRelativeUrl(originalUri || '/', window.location.origin));
};

export function WrappedSecurity({ children }: { children: ReactNode }) {
  const [flag, setFlag] = useState<boolean | undefined>(undefined);

  const { data: oktaData, status } = useQuery([getIsOktaOnKey, 'getIsOktaOn'], () => getIsOktaOn());

  useEffect(() => {
    if (status !== 'loading') {
      if (oktaData?.Data?.OktaPortalEnabled) {
        // Additional check in case the okta flag is on but somehow keys are not punched in.
        // Sighting the case if we turned on FF before deploying the build or the client
        // did not get the updated build with keys but gets flag on (maybe due to caching)
        if (process.env.REACT_APP_OKTA_ISSUER && process.env.REACT_APP_OKTA_CLIENT_ID) {
          setFlag(true);
        } else {
          setFlag(false);
        }
      } else {
        setFlag(false);
      }
    }
  }, [status, oktaData]);

  const getOktaAuth = (flag) => {
    let oktaAuth;
    if (flag) {
      const origin = window.location.origin;
      oktaAuth = new OktaAuth({
        issuer: process.env.REACT_APP_OKTA_ISSUER,
        clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
        redirectUri: `${origin}/login/callback`,
        logoutUrl: `${origin}/logout`,
        transformAuthState: async (oktaAuth, authState) => {
          if (!authState.isAuthenticated) {
            return authState;
          }
          // extra requirement: user must have valid Okta SSO session
          const user = await oktaAuth.token.getUserInfo();
          authState.isAuthenticated = !!user; // convert to boolean
          authState.users = user; // also store user object on authState
          return authState;
        },
      });
    }
    return oktaAuth;
  };

  if (flag === undefined) {
    return <></>;
  }

  if (flag) {
    return (
      <Security restoreOriginalUri={restoreOriginalUri} oktaAuth={getOktaAuth(flag)}>
        {children}
      </Security>
    );
  }
  return <>{children}</>;
}
